import {ApiStatus, SavedBlock} from '../../models';
import {SavedBlockAction, SavedBlockActionTypes,} from '../actions/savedBlockActions';

export const initialSavedBlockState: ISavedBlockState = {
  loadingStatus: ApiStatus.LOADING,
  creatingStatus: null,
  updatingStatus: null,
  deletingStatus: ApiStatus.LOADED,
  blocks: [],
};

export interface ISavedBlockState {
  loadingStatus: ApiStatus;
  creatingStatus: ApiStatus | null;
  updatingStatus: ApiStatus | null;
  deletingStatus: ApiStatus;
  blocks: SavedBlock[];
}

export default function savedBlockReducer(
  state: ISavedBlockState = initialSavedBlockState,
  action: SavedBlockAction
): ISavedBlockState {
  switch (action.type) {
    case SavedBlockActionTypes.LOAD_SAVED_BLOCKS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING,
      };
    case SavedBlockActionTypes.LOADED_SAVED_BLOCKS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADED,
        blocks: action.payload.result,
      };
    case SavedBlockActionTypes.LOADING_SAVED_BLOCKS_FAILED:
      return {
        ...state,
        loadingStatus: ApiStatus.FAILED,
      };
    case SavedBlockActionTypes.CREATE_SAVED_BLOCK:
      return {
        ...state,
        creatingStatus: ApiStatus.LOADING,
      };
    case SavedBlockActionTypes.CREATED_SAVED_BLOCK:
      return {
        ...state,
        creatingStatus: ApiStatus.LOADED,
        blocks: [
          action.payload,
          ...state.blocks || [],
        ],
      };
    case SavedBlockActionTypes.CREATING_SAVED_BLOCK_FAILED:
      return {
        ...state,
        creatingStatus: ApiStatus.FAILED,
      }
    case SavedBlockActionTypes.DELETE_SAVED_BLOCK:
      return {
        ...state,
        deletingStatus: ApiStatus.LOADING,
      }
    case SavedBlockActionTypes.DELETED_SAVED_BLOCK:
      return {
        ...state,
        blocks: state.blocks?.filter(b => b.uid !== action.payload) || [],
        deletingStatus: ApiStatus.LOADED,
      }
    case SavedBlockActionTypes.DELETING_SAVED_BLOCK_FAILED:
      return {
        ...state,
        deletingStatus: ApiStatus.FAILED,
      }

    default:
      return state;
  }
}
